
import vue from 'vue';
import PredialService from '@/services/PredialService';
import rules from '@/mixins/rules';

export default vue.extend({
    name: 'PredialEstadoCuenta',
    mixins: [rules],
    props: {
        dialogEstadoCuenta: {
            type: Boolean,
            default: false
        },
        establecimiento: {
            type: Object,
            default: null as any
        }
    },
    data: () => ({
        dialogDocument: false,
        dialogSolicitud: false,
        documento: null as any,
        datosPredio: null as any,
        initialYear: 2010,
        parcialidad: 2 as any,
        currentYear: new Date().getFullYear(),
        year: new Date().getFullYear(),
        formEdoCuenta: {
            claveCatastral: null,
            tipoCuenta: 2,
            bimestre: null,
            yearInicio: null,
            yearFinal: null,
            ultimoPagoPredial: null as any,
        },
        formEdoCuentaDesglosado: {
            claveCatastral: null,
            tipoCuenta: null,
            bimestre: null,
            yearInicio: null,
            yearFinal: null,
            avaluos: [] as any,
            datosPredio: {} as any,
            ultimoPagoPredial: null as any,
        },
        avaluos: [] as any,
        pagos: {} as any,
        claveCatastral: '',
        parcialidades: [
            { id: 2, descripcion: '2 parcialidades' },
            { id: 3, descripcion: '3 parcialidades' },
            { id: 4, descripcion: '4 parcialidades' },
        ],
    }),
    methods: {
        closeEstadoCuenta() {
            //@ts-ignore
            this.formEdoCuentaDesglosado = {
                claveCatastral: null,
                tipoCuenta: null,
                bimestre: null,
                yearInicio: null,
                yearFinal: null,
                avaluos: [] as any,
                datosPredio: {} as any,
            }
            this.avaluos = [] as any;
            this.$emit('closeEstadoCuenta');
        },
        generarEdoCuentaSolicitudes() {
            console.log(this.establecimiento.clave_catastral);
            PredialService.generarEdoCuentaSolicitudesPublic(this.formEdoCuenta)
                .then((response) => {
                    let file = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(file);
                    const tipoArchivo = 'Estado de cuenta'
                    //@ts-ignore
                    this.documento = {
                        title: tipoArchivo,
                        url: url,
                        mime: response.headers['content-type']
                    }
                    this.dialogDocument = true;
                })
        },
        generarEdoCuentaDesglosado() {
            let data = {
                claveCatastral: this.formEdoCuentaDesglosado.claveCatastral,
                tipoCuenta: this.formEdoCuentaDesglosado.tipoCuenta,
                bimestre: this.formEdoCuentaDesglosado.bimestre,
                yearInicio: this.formEdoCuentaDesglosado.yearInicio,
                yearFinal: this.formEdoCuentaDesglosado.yearFinal,
                avaluos: [],
                datosPredio: this.formEdoCuentaDesglosado.datosPredio,
            }
            PredialService.generarEdoCuentaDesglosadoSolicitudPublic(data)
                .then((response) => {
                    let file = new Blob([response.data], { type: response.headers['content-type'] });
                    const url = window.URL.createObjectURL(file);
                    const tipoArchivo = 'Estado de cuenta'
                    //@ts-ignore
                    this.documento = {
                        title: tipoArchivo,
                        url: url,
                        mime: response.headers['content-type']
                    }
                    this.dialogDocument = true;
                })
        },
    },
    computed: {
        arrayYears() {
            let arrayYears: any = [];
            for (let i = this.currentYear; i >= this.initialYear; i--) {
                arrayYears.push(i);
            }
            return arrayYears;
        },
    },
    watch: {
        dialogEstadoCuenta: function () {
            if (this.dialogEstadoCuenta) {
                this.formEdoCuenta.claveCatastral = this.establecimiento.clave_catastral;
                this.formEdoCuentaDesglosado.claveCatastral = this.establecimiento.clave_catastral;
            }
        },
    }
});
